<template>
  <span v-if="!cta" class="cta-result-cell__empty">-</span>

  <bg-tooltip
    v-else-if="isFillData"
    variant="dark"
    trigger="hover"
    placement="bottom"
    :closable="false"
  >
    <ul class="cta-result-cell__preview" data-testid="fill-data-preview">
      <li
        v-for="(field, index) in cta.display_value"
        :key="index"
        class="cta-result-cell__preview-item"
      >
        <span class="cta-result-cell__preview-text">
          {{ field.value }}
        </span>
      </li>
    </ul>

    <template #tooltip-content>
      <ul class="cta-result-cell__fields">
        <li v-for="(field, index) in cta.display_value" :key="index">
          {{ field.value }}
        </li>
      </ul>
    </template>
  </bg-tooltip>

  <bg-label v-else color="green" :title="ctaLabel">
    {{ cta.display_value }}
  </bg-label>
</template>

<script>
import { computed } from '@vue/composition-api';
import { BgLabel, BgTooltip } from 'bangul-vue';

export default {
  name: 'CtaResultCell',

  components: {
    BgLabel,
    BgTooltip,
  },

  props: {
    // A result CTA: { label, action_type, display_value } or null.
    cta: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const isFillData = computed(() => props.cta?.action_type === 'fill_data');

    const ctaLabel = computed(() => {
      const label = props.cta?.label;

      return Array.isArray(label) ? label.join(', ') : label || '';
    });

    return {
      isFillData,
      ctaLabel,
    };
  },
};
</script>

<style lang="scss" scoped src="./CtaResultCell.scss" />
